import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
export function PriceAnchor() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="py-24 px-6 bg-dark-bg" data-id="element-140">
      <div className="max-w-3xl mx-auto text-center" data-id="element-141">
        <motion.h2 initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="text-3xl md:text-5xl font-serif font-bold text-text-primary mb-3" data-id="element-142">
          Hoy puedes acceder a todo esto por solo{' '}
          <span className="text-accent" data-id="element-143">€4.99</span>
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="mt-10 mb-12" data-id="element-144">
          <p className="text-lg md:text-xl text-text-secondary mb-1" data-id="element-145">
            Por menos de lo que cuesta un café…
          </p>
          <p className="text-xl md:text-2xl text-text-primary font-semibold" data-id="element-146">
            tienes todo lo necesario para empezar hoy mismo.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6,
        delay: 0.4
      }} data-id="element-147">
          <p className="text-lg md:text-xl text-text-secondary mb-2" data-id="element-148">
            No es el precio lo que importa…
          </p>
          <p className="text-xl md:text-2xl font-serif font-bold text-accent" data-id="element-149">
            es lo que puede pasar si no empiezas.
          </p>
        </motion.div>
      </div>
    </section>;
}